import { translate } from '../helperFunctions'
import { map } from '../map/tools'
import { codemap } from '../storage'

function getAllMinimaps() {
  let all = [];
  const htmlCollection = document.getElementsByClassName('minimap');
  const l = htmlCollection.length;
  for (let i = 0; i < l; i++) {
    all.push(htmlCollection[i].data);
  }
  return all;
}

export const getMapsToBeSteered = (btnId) => {
  if (btnId === '' || !btnId) return [map];
  if (btnId === 'K_all') return [map].concat(getAllMinimaps());
  const i = btnId.slice(1);
  const b = document.getElementById('minimap' + i + '_b').data;
  const a = document.getElementById('minimap' + i + '_a').data;
  return [b, a];
};

export function getReadableValue(v, property) {
  let text = '';
  if (v === '' || v === '--') { return v; }
  if (property.includes('anleggstype')) {
    text = translate(codemap['anleggstype'][v]);
  } else if (property.includes('datafangstmetode')) {
    text = translate(codemap['datafangstmetode'][v]);
  } else if (property.includes('reinbeitebruker')) {
    text = translate(codemap['reinbeitebruker'][v]);
  } else if (property.includes('reinbeiteområde')) {
    text = translate(codemap['reinbeiteomrade'][v]);
  } else if (property.includes('dom_instans')) {
    text = translate(codemap['dominstans'][v]);
  } else if (property.includes('sesongomrade')) {
    text = translate(codemap['sesongomrade'][v]);
  } else if (property.indexOf('status') === 0) {
    text = i18n[property][v];
  } else if (property.includes('opphav') || property.includes('saksbehandler')) {
    text = v;
  } else if (property.includes('dato')) {
    // convert date from ISO format To Norwegian format;
    text = new Date(v).toLocaleDateString();
  } else {
    text = translate(v);
  }
  return text;
}

function isMiniK(btnId) {
  if (btnId.startsWith('K')) { return true; }
  return false;
}
